import HttpServices from './index';

class UsersService extends HttpServices {
  getCurrent = () => this.http.get('/users/current');
}

export default new UsersService();
